module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "新增课程音频",
      "width": "600px"
    },
    on: {
      "on-ok": _vm.saveData
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "audioForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.audioRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本",
      "prop": "version",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": ""
    },
    on: {
      "on-change": _vm.onVersionChange
    },
    model: {
      value: (_vm.formData.version),
      callback: function($$v) {
        _vm.$set(_vm.formData, "version", _vm._n($$v))
      },
      expression: "formData.version"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择开始Level",
      "prop": "levelId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onLevelChange
    },
    model: {
      value: (_vm.formData.levelId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelId", _vm._n($$v))
      },
      expression: "formData.levelId"
    }
  }, _vm._l((_vm.levels), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程",
      "prop": "lessonId",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true,
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lessonId", _vm._n($$v))
      },
      expression: "formData.lessonId"
    }
  }, _vm._l((_vm.lessons), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "音频标题",
      "prop": "title",
      "label-width": 100
    }
  }, [_c('Input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传音频",
      "label-width": 100,
      "prop": "audioUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleChange,
      "on-success": _vm.handleSuccess,
      "headers": _vm.headers,
      "on-progress": _vm.handleProgress,
      "before-upload": _vm.beforeUpload,
      "accept": "audio/mpeg",
      "limit": 2,
      "multiple": "",
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0adff8d7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/LessonAudioInsertModal.vue
// module id = 1632
// module chunks = 8